import { useState, useEffect } from 'react';
import { sliderAPI, IMAGE_BASE } from '../../services/api';

export default function SliderAdmin() {
    const [sliders, setSliders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [form, setForm] = useState({
        badge: '', title: '', description: '', buttonText: 'Ürünleri Keşfet', buttonLink: '/urunler',
        buttonText2: '', buttonLink2: '', sortOrder: 0, isActive: true
    });
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [formBusy, setFormBusy] = useState(false);

    const fetchSliders = async () => {
        setLoading(true);
        try {
            const res = await sliderAPI.getAll();
            setSliders(res.data || []);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { fetchSliders(); }, []);

    const openCreate = () => {
        setEditItem(null);
        setForm({ badge: '', title: '', description: '', buttonText: 'Ürünleri Keşfet', buttonLink: '/urunler', buttonText2: '', buttonLink2: '', sortOrder: 0, isActive: true });
        setImageFile(null);
        setImagePreview(null);
        setShowModal(true);
    };

    const openEdit = (item) => {
        setEditItem(item);
        setForm({
            badge: item.badge || '', title: item.title || '', description: item.description || '',
            buttonText: item.buttonText || '', buttonLink: item.buttonLink || '',
            buttonText2: item.buttonText2 || '', buttonLink2: item.buttonLink2 || '',
            sortOrder: item.sortOrder || 0, isActive: item.isActive
        });
        setImageFile(null);
        setImagePreview(item.image ? IMAGE_BASE + item.image : null);
        setShowModal(true);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormBusy(true);
        try {
            const fd = new FormData();
            Object.entries(form).forEach(([k, v]) => fd.append(k, v));
            if (imageFile) fd.append('image', imageFile);

            if (editItem) {
                await sliderAPI.update(editItem.id, fd);
            } else {
                await sliderAPI.create(fd);
            }
            setShowModal(false);
            fetchSliders();
        } catch (err) {
            alert(err.response?.data?.error || 'Hata oluştu');
        }
        setFormBusy(false);
    };

    const handleDelete = async (id) => {
        if (!confirm('Bu slider\'ı silmek istediğinize emin misiniz?')) return;
        try {
            await sliderAPI.delete(id);
            fetchSliders();
        } catch (err) {
            alert(err.response?.data?.error || 'Silinemedi');
        }
    };

    return (
        <div>
            <div className="admin-header">
                <h1>Slider Yönetimi</h1>
                <button className="btn btn-primary" onClick={openCreate}>+ Yeni Slide</button>
            </div>

            {loading ? <div className="loading"><div className="spinner"></div></div> : (
                <div className="data-table-wrapper">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Görsel</th>
                                <th>Başlık</th>
                                <th>Badge</th>
                                <th>Sıra</th>
                                <th>Durum</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sliders.map(item => (
                                <tr key={item.id}>
                                    <td>
                                        {item.image ? (
                                            <img src={IMAGE_BASE + item.image} alt={item.title} style={{ width: 80, height: 45, objectFit: 'cover', borderRadius: 6 }} />
                                        ) : <span style={{ color: 'var(--text-muted)' }}>-</span>}
                                    </td>
                                    <td style={{ fontWeight: 600 }}>{item.title}</td>
                                    <td style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>{item.badge || '-'}</td>
                                    <td>{item.sortOrder}</td>
                                    <td>
                                        <span className={`stock-badge ${item.isActive ? 'stock-in' : 'stock-out'}`}>
                                            {item.isActive ? 'Aktif' : 'Pasif'}
                                        </span>
                                    </td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                                            <button className="btn-icon" onClick={() => openEdit(item)}>✏️</button>
                                            <button className="btn-icon" onClick={() => handleDelete(item.id)} style={{ color: 'var(--danger)' }}>🗑️</button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            {sliders.length === 0 && (
                                <tr><td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Henüz slider eklenmemiş</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && setShowModal(false)}>
                    <div className="modal" style={{ maxWidth: 600 }}>
                        <div className="modal-header">
                            <h2>{editItem ? 'Slide Düzenle' : 'Yeni Slide'}</h2>
                            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                <div className="form-group">
                                    <label>Görsel</label>
                                    <input type="file" accept="image/*" onChange={handleImageChange} className="form-control" />
                                    {imagePreview && (
                                        <img src={imagePreview} alt="Preview" style={{ width: '100%', height: 150, objectFit: 'cover', borderRadius: 8, marginTop: 8 }} />
                                    )}
                                </div>
                                <div className="form-group">
                                    <label>Badge</label>
                                    <input className="form-control" value={form.badge} onChange={e => setForm({ ...form, badge: e.target.value })} placeholder="ör: Yeni Koleksiyon" />
                                </div>
                                <div className="form-group">
                                    <label>Başlık *</label>
                                    <input className="form-control" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} required />
                                </div>
                                <div className="form-group">
                                    <label>Açıklama</label>
                                    <textarea className="form-control" rows={3} value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} />
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>Buton 1 Metin</label>
                                        <input className="form-control" value={form.buttonText} onChange={e => setForm({ ...form, buttonText: e.target.value })} />
                                    </div>
                                    <div className="form-group">
                                        <label>Buton 1 Link</label>
                                        <input className="form-control" value={form.buttonLink} onChange={e => setForm({ ...form, buttonLink: e.target.value })} />
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>Buton 2 Metin</label>
                                        <input className="form-control" value={form.buttonText2} onChange={e => setForm({ ...form, buttonText2: e.target.value })} />
                                    </div>
                                    <div className="form-group">
                                        <label>Buton 2 Link</label>
                                        <input className="form-control" value={form.buttonLink2} onChange={e => setForm({ ...form, buttonLink2: e.target.value })} />
                                    </div>
                                </div>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                    <div className="form-group">
                                        <label>Sıra</label>
                                        <input type="number" className="form-control" value={form.sortOrder} onChange={e => setForm({ ...form, sortOrder: parseInt(e.target.value) || 0 })} />
                                    </div>
                                    <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                                            <input type="checkbox" checked={form.isActive} onChange={e => setForm({ ...form, isActive: e.target.checked })} /> Aktif
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>İptal</button>
                                <button type="submit" className="btn btn-primary" disabled={formBusy}>
                                    {formBusy ? 'Kaydediliyor...' : (editItem ? 'Güncelle' : 'Ekle')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
